// @flow
import { of } from 'rxjs';
import { mergeMap, map, catchError, delay } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { createTicketApi } from './api';
import { setNewAlert } from '../alert/duck';

import type { HTTPError } from '../../error';
import type { Observable } from 'rxjs'
import type { TicketRequest } from './api';

export type HelpTicketAction = {
  +type: string;
  +request?: TicketRequest;
  +error?: HTTPError;
};

export type HelpTicketState = {
  +isCreatingTicket?: boolean;
  +createTicketSuccessful?: boolean;
  +createTicketError?: HTTPError;
};

// Actions
const HELP_TICKET_CREATE_TICKET_REQUEST = 'HELP_TICKET_CREATE_TICKET_REQUEST';
const HELP_TICKET_CREATE_TICKET_SUCCESS = 'HELP_TICKET_CREATE_TICKET_SUCCESS';
const HELP_TICKET_CREATE_TICKET_ERROR = 'HELP_TICKET_CREATE_TICKET_ERROR';

// Actions creators
export function createTicket(request: TicketRequest): HelpTicketAction {
  return {
    type: HELP_TICKET_CREATE_TICKET_REQUEST,
    request,
  }
}

export function createTicketSuccess(): HelpTicketAction {
  return {
    type: HELP_TICKET_CREATE_TICKET_SUCCESS,
  }
}

export function createTicketErrorFn(error: HTTPError): HelpTicketAction {
  return {
    type: HELP_TICKET_CREATE_TICKET_ERROR,
    error,
  }
}

export const actions = {
  HELP_TICKET_CREATE_TICKET_REQUEST,
  HELP_TICKET_CREATE_TICKET_SUCCESS,
  HELP_TICKET_CREATE_TICKET_ERROR,
  createTicket,
  createTicketSuccess,
  createTicketErrorFn,
};

export const initialState: HelpTicketState = {};

// Reducer
export default function reducer(state: HelpTicketState = initialState,
                                action: HelpTicketAction): HelpTicketState {
  switch (action.type) {
    case HELP_TICKET_CREATE_TICKET_REQUEST:
      return {
        ...state,
        isCreatingTicket: true,
        createTicketSuccessful: undefined,
        createTicketError: undefined,
      };
    case HELP_TICKET_CREATE_TICKET_SUCCESS:
      return {
        ...state,
        isCreatingTicket: false,
        createTicketSuccessful: true,
      };
    case HELP_TICKET_CREATE_TICKET_ERROR:
      return {
        ...state,
        isCreatingTicket: false,
        createTicketError: action.error,
      };
    default:
      return state;
  }
}

// Epics
export function createTicketEpic(action$: Observable<HelpTicketAction>): Observable<HelpTicketAction> {
  return action$.pipe(
    ofType(HELP_TICKET_CREATE_TICKET_REQUEST),
    delay(1500),
    mergeMap(({ request }) => createTicketApi({ ...request }).pipe(
      map(createTicketSuccess),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(createTicketErrorFn(e),
            setNewAlert('help-ticket', 'error', undefined, 'httpErrors.fetch.500'),
          );
        } else if (e.code === 400) {
          return of(createTicketErrorFn(e),
            setNewAlert('help-ticket', 'error', undefined, 'httpErrors.fetch.400'),
          );
        }
        return of(createTicketErrorFn(e));
      }),
    )),
  );
}



// WEBPACK FOOTER //
// ./src/modules/help-ticket/duck.js